<template>
  <div class="dialogs">
    <el-dialog :visible.sync="dialog.visible" width="30%" :close-on-click-modal="false" :append-to-body="true">
      <div class="close-icon" @click="handleClose"></div>
      <div class="title">工单信息</div>
      <div class="inner">
        <div class="notice-line">基础信息</div>
        <div class="common-form">
          <el-form label-width="100px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="报修人:">
                  <el-input v-model="form.reporter" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报修地址:">
                  <el-input v-model="form.position_name" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="故障地址:">
                  <el-input v-model="form.position_des" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工单号:">
                  <el-input v-model="form.work_order_no" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="时间:">
                  <el-input v-model="form.work_order_time" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工单状态:">
                  <div :style="{'font-size':'24px','color':form.work_order_state==='已核销'?'#ff0000':'#19b16e'}">{{ form.work_order_state }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="notice-line">报修信息</div>
        <div class="common-form">
          <el-form label-width="100px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="工单描述：">
                  <el-input v-model="form.report_inf" type="textarea" :rows="2" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人:">
                  <el-input v-model="form.maintenance_worker" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号:">
                  <el-input v-model="form.phone" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!-- <div class="btns">
        <div class="btn ensure-btn" @click="handleEnsure">确定</div>
        <div class="btn close-btn" @click="handleClose">取消</div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Dialogs',
  components: {},
  props: {
    dialogState: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      dialog: {
        visible: false,
        method: '',
        params: ''
      },
      form: {}
    }
  },
  watch: {
    dialogState: {
      handler(newVal) {
        this.dialog = {
          visible: newVal.visible,
          method: newVal.method,
          params: newVal.params
        }
        if (newVal.visible) {
          this.handleDialogState()
        }
      },
      deep: true
    }
  },
  created() {},
  methods: {
    handleClose() {
      this.dialogState.visible = false
    },
    handleEnsure() {
      this.dialogState.visible = false
    },
    handleDialogState() {
      this.form = this.dialog.params
      this.form.work_order_time = this.moment(this.form.work_order_time).format('yyyy-MM-DD HH:mm:ss')

      for (const i in this.form) {
        if (!this.form[i]) {
          this.form[i] = '暂无'
        }
      }
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .inner{
  padding: 40px 40px 0;
  .notice-line{
    padding: 8px;
    border-bottom: 1px solid #666;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .common-form{
    padding:35px 100px 0 100px ;
    .el-textarea__inner{
      height: 200px;
      width: 100%;
      background:url(../../../assets/area-bgi.png) no-repeat;
      background-size: 100% 100%;
      border: none;
      color: #fff;
      font-size: 16px;
    }
    .el-form-item__label{
      text-align: left;
      letter-spacing: 1px;
      width: 75px;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 0.5;
    }
    .el-date-editor{
      width: 100%;
      .el-input__inner{
        color: #fff;
        font-size: 16px;
      }
    }
    .el-input{
      .el-input__inner{
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .seeDetail{
    color: deepskyblue;
    cursor: pointer;
  }
    .el-table__body tr,
  .el-table__body td {
    padding: 10px 0;
    border-top: 3px solid #010B2A;
    border-bottom: 3px solid #010B2A;

}
  .common-pagination{
    bottom: 60px;
  }
}

</style>
